import { render } from "./SpecialNotificationUsers.vue?vue&type=template&id=ec0c909a&scoped=true"
import script from "./SpecialNotificationUsers.vue?vue&type=script&lang=js"
export * from "./SpecialNotificationUsers.vue?vue&type=script&lang=js"

import "./SpecialNotificationUsers.vue?vue&type=style&index=0&id=ec0c909a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0c909a"]])

export default __exports__